export default __webpack_public_path__ + "static/media/gmaps_icon.4f834ead.png";